import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgForage, NgForageCache, CachedItem } from 'ngforage';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class UserService {
  constructor(
    private ngf: NgForage,
    private ngfCache: NgForageCache,
  ) { }
  

  /**
   * Enregistrer l'utlisateur en storage
   * @param user Objet à enregistrer en storage
   */
  setUser ( user: object ):Promise<any> {
    return this.ngfCache.setCached<any>('user', user);
  }

  /**
   * Récupèrer l'utilisateur, si aucune valeur ou cache est périmé, on renvoie null
   */
  getUser ():Promise<any> {
    return this.ngfCache.getCached<any>('user')
      .then((r: CachedItem<any>) => {
        if (!r.hasData || r.expired) {
          return null;
        }
        return r.data;
      })
  }
  /**
   * Supprime l'utilisateur du storage
   */
  deleteUser ():Promise<void>{
    return this.ngfCache.removeCached('user');
  }
}



// WEBPACK FOOTER //
// ./src/app/helper/core/user.service.ts